import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@classifieds-sell/auth';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'tm-sell-a-property',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    public error: string;
    public userInitialised: boolean;
    public userName: string;
    public isModalActive: boolean;

    title = 'Property Sell';

    constructor(
        private router: Router,
        private authService: AuthService,
        private changeDectorRef: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.initApp();
    }

    initApp() {
        this.router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe((_) => window.scrollTo(0, 0));

        from(this.authService.userManager.getUser()).subscribe((user) => {
            this.userInitialised = user != null;
            this.userName = user?.profile?.name || '';
            this.changeDectorRef.markForCheck();
        });
    }

    updateIsModalActive(isModalActive: boolean): void {
        this.isModalActive = isModalActive;
    }
}
